import React, { useState } from 'react';
import Modal, { ModalContent } from './modal';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Form } from './form/form';
import DemoStep1 from './DemoStep1';
import DemoStep2 from './DemoStep2';
import DemoStepThanks from './DemoStepThanks';
import { trackEvent, getStateOptions } from '../utilities';
import 'isomorphic-fetch';
import { graphql } from '../../../homespotter/intranet_tools/api/';
import { setAPIToken } from '../../../homespotter/intranet_tools/api/graphql';
import { API_TOKEN } from '../constants/globalConstants.js';
import { DEMO_REQUEST_FORM, PRODUCT_NAME_CHECKBOXES} from "../constants/demoRequestsConstants";

const ViewDemo  = props => {
    const [step, setStep] = useState(1);

    const { executeRecaptcha } = useGoogleReCaptcha();


    const handleNext = () => {
        setStep(2);
    }

    const onClose = () => {
        setStep(1);
        if(props.onModalClose) {
            props.onModalClose();
        }
    }

    const submitDemoRequest = (form, token) => {
        
        const query = `
            mutation CreateDemoRequest($input: DemoRequestInput!) {
                createDemoRequest(demoRequest: $input) {
                    lead {email}
                }
            }`;

        const variables = {
            input: {
                recaptchaToken: token,
                sourceForm: DEMO_REQUEST_FORM,
                message: form['message'],
                lead: {
                    homeState: form['home_state'],
                    firstName: form['first_name'],
                    lastName: form['last_name'],
                    companyName: form['company'],
                    email: form['email'],
                    phone: form['phone'],
                    agentCount: form['agentCount'],
                    businessType: form['chooseYourBusiness'],
                    interestedInBoost: form['interested_in_boost'],
                    interestedInSpacio: form['interested_in_spacio'],
                    interestedInConnect: form['interested_in_connect'],
                },
            },
        };

        setAPIToken(API_TOKEN);

        const retry = false;
        graphql({ query, variables, retry }).catch(err => console.log(err));

        trackEvent(form);

        setStep(3);
    }

    const handleReCaptchaVerify = (form) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        executeRecaptcha('contact').then((token) => {
            submitDemoRequest(form, token);
        });
    }

    let stepComponent;
    switch (step) {
        case 1:
            stepComponent = <DemoStep1 handleNext={handleNext} />
            break
        case 2:
            stepComponent = (
                <DemoStep2 stateOptions={getStateOptions()} />
            )
            break
        default:
            stepComponent = <DemoStepThanks />
    }

    const checked = props.checked && props.checked.toLowerCase();

    return (
        <Modal
            callToAction={props.children}
            targetTag={props.targetTag}
            targetClassName={props.targetClassName}
            onClose={onClose}
            openByDefault={!!props.openByDefault}
        >
            <ModalContent>
                <Form
                    initialValues={{
                        [PRODUCT_NAME_CHECKBOXES[checked]]: true,
                        chooseYourBusiness: props.businessType
                    }}
                    onSubmit={handleReCaptchaVerify}
                >
                    {stepComponent}
                </Form>
            </ModalContent>
        </Modal>
    )

}

export default ViewDemo;
